import React from 'react';
import PropTypes from 'prop-types';
import { cn } from "../../../utils/helper";

const CommonButton = ({
    text,
    onClick,
    type = "button",
    className = "",
    disabled = false,
    style = {},
    form
}) => {

    const defaultClassName =
        "text-[14px] font-medium h-[40px] px-4 py-1 rounded-[100px] bg-shoorah-active text-white";

    return (
        <button
            // className={`${overrideDefaults ? "" : defaultClassName} ${className} capitalize ${disabled ? "opacity-50 cursor-not-allowed" : ""
            //     }`}
            className={cn("text-[14px] font-medium h-[40px] md:px-4 px-2 py-1 rounded-[100px] bg-shoorah-active text-white capitalize",
                {
                    "opacity-50 cursor-not-allowed":
                        disabled,
                }, className)}
            type={type}
            onClick={onClick}
            disabled={disabled}
            style={style}
            form={form}
        >
            {text}
        </button>
    );
};

CommonButton.propTypes = {
    text: PropTypes.string.isRequired, // Button text
    onClick: PropTypes.func.isRequired, // Click event handler
    type: PropTypes.oneOf(["button", "submit", "reset"]), // Button type
    className: PropTypes.string, // Additional CSS classes
    disabled: PropTypes.bool, // Disable the button
    style: PropTypes.object, // Inline styles
};

export default CommonButton;
